// Наборы окна «Экспорт данных»: подписи, иконки и подсказки. ready — выгрузка уже есть на сервере;
// диалоги и сообщения появятся вместе с подключением каналов (этап 3), сервер на них отвечает dataset_not_ready.
import { t } from "@/lib/i18n";

export type ExportDataset = {
  id: string;
  label: string;
  icon: string;
  hint: string;
  ready: boolean;
};

export const exportDatasets: ExportDataset[] = [
  {
    id: "contacts",
    label: t("Контакты"),
    icon: "ri-contacts-book-2-line",
    hint: t("Карточки клиентов: имена, телефоны, почта, компании, этапы, теги и свои поля"),
    ready: true,
  },
  {
    id: "conversations",
    label: t("Диалоги"),
    icon: "ri-chat-3-line",
    hint: t("Каналы, ответственные продавцы, статус и время ответа"),
    ready: false,
  },
  {
    id: "messages",
    label: t("Сообщения"),
    icon: "ri-message-3-line",
    hint: t("Тексты, вложения, автор и время отправки по каждому диалогу"),
    ready: false,
  },
  {
    id: "failed-messages",
    label: t("Неудавшиеся сообщения"),
    icon: "ri-error-warning-line",
    hint: t("Что не доставилось: канал, причина ошибки и повторная отправка"),
    ready: false,
  },
];

export const NOT_READY_NOTE = t("появится с подключением каналов (этап 3)");
